import * as ast from '../../generated/ast.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateButton(nodeFields, pifFileSummary, accept) {
    const { idField, richAssetField } = nodeFields;
    if (!richAssetField || !ast.isRichAssetButton(richAssetField?.content))
        return;
    const buttonString = richAssetField?.content?.value?.trim() ?? '';
    // This could either be a static or dynamic button content based on the string format
    if (buttonString.startsWith('{') && buttonString.endsWith('}')) {
        const indexOfStar = buttonString.indexOf('*');
        if (indexOfStar === -1) {
            accept('error', `The dynamic button content is not formatted correctly. It should be in the format '{ source_node * source_var }'.`, {
                node: richAssetField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: nodeFields.nodeNumber,
                    propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                },
            });
        }
        else {
            // Split the string into it's parts. Account for start and end parenthesis
            const nodeNumber = buttonString.slice(1, indexOfStar).trim();
            const variableName = buttonString
                .slice(indexOfStar + 1, buttonString.length - 1)
                .trim();
            // The referenced node must exist
            const refNodeFields = pifFileSummary.getNodeByNodeNumber(nodeNumber);
            if (!refNodeFields) {
                accept('error', `Could not resolve reference to Node named '${nodeNumber}'.`, {
                    node: richAssetField,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: nodeFields.nodeNumber,
                        propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                    },
                });
            }
            else {
                // The referenced node exists. Get the required fields for the referenced node.
                const { outputField: refOutputField } = refNodeFields;
                // The variable must exist on the referenced node
                const matchingOutputVariable = refOutputField?.output?.find((o) => {
                    return o.value === variableName;
                });
                if (!matchingOutputVariable) {
                    accept('error', `The referenced variable '${variableName}' does not exist on the referenced node '${refNodeFields.nodeNumber}'.`, {
                        node: richAssetField,
                        data: {
                            id: idField?.id?.value,
                            nodeNumber: nodeFields.nodeNumber,
                            propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                        },
                    });
                }
            }
        }
    }
    else {
        // For static button string, we can have multiple button items separated by a pipe
        // Filter out empty strings from the array returned by split function
        const buttons = buttonString.split('|').filter(Boolean);
        buttons.forEach((button) => {
            // Each individual button has the format label~destination
            // Get the individual parts of the button string
            const indexOfTilde = button.indexOf('~');
            if (indexOfTilde === -1) {
                accept('error', `The static button content '${button}' is not formatted correctly. It should be in the format 'label ~ destination'.`, {
                    node: richAssetField,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: nodeFields.nodeNumber,
                        propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                    },
                });
            }
            else {
                // Split the string into it's parts.
                // const label = button.slice(0, indexOfTilde).trim();
                const nodeNumber = button.slice(indexOfTilde + 1).trim();
                // The referenced node must exist
                const refNodeFields = pifFileSummary.getNodeByNodeNumber(nodeNumber);
                if (!refNodeFields) {
                    accept('error', `Could not resolve reference to Node named '${nodeNumber}'.`, {
                        node: richAssetField,
                        data: {
                            id: idField?.id?.value,
                            nodeNumber: nodeFields.nodeNumber,
                            propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                        },
                    });
                }
            }
        });
    }
}
//# sourceMappingURL=button.js.map